import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root'
})
export class AppMatSidenavHelperService {
  public sidenavInstance: Map<string, MatSidenav>;

  constructor() {
    this.sidenavInstance = new Map<string, MatSidenav>();
  }

  setSidenav(id: string, instance: MatSidenav): void {
    this.sidenavInstance.set(id, instance);
  }

  getSidenav(id: string): MatSidenav | null {
    return this.sidenavInstance.get(id) ?? null;
  }

}
